import { SearchableSelect } from "../fields/searchable-select"
import type { TemplateV2 } from "../types"
import { useTranslation } from "@/hooks/use-translation"

export interface TemplateSectionProps {
  value: string | null
  options: TemplateV2[]
  disabled: boolean
  placeholder: string
  onChange: (id: string | null) => void
}

export function TemplateSection({
  value,
  options,
  disabled,
  placeholder,
  onChange,
}: TemplateSectionProps) {
  const { t } = useTranslation()
  const noTemplates = !disabled && options.length === 0

  return (
    <section>
      <h3 className="text-sm font-semibold text-gray-800 uppercase tracking-wider mb-3">
        {t("sectionTemplate")}
      </h3>
      {noTemplates ? (
        <p className="text-sm text-muted-foreground">
          {t("noTemplatesForClientLob")}
        </p>
      ) : (
        <SearchableSelect
          label={t("labelChooseTemplate")}
          value={value}
          onValueChange={onChange}
          options={options}
          placeholder={placeholder}
          disabled={disabled}
          onClear={() => onChange(null)}
        />
      )}
    </section>
  )
}
